<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Fixed Asset - Form 
        <div class="card-header-actions">
          <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row >
          <b-col lg="7" class="pr-5">
                <b-row >
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Fixed Asset Number</label></b-input-group-prepend>
                        <b-form-input v-model="model.asetid" readonly></b-form-input>  
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">      
                    <b-input-group >
                        <b-input-group-prepend><label>Acquisition Date</label></b-input-group-prepend>
                        <b-form-input  v-model="model.asdatacq" type="date" disabled></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>

                <b-input-group >
                    <b-input-group-prepend><label>Fixed Asset Name</label></b-input-group-prepend>
                    <b-form-input v-model="model.asdesc" :state="!$v.model.asdesc.$error"></b-form-input>
                </b-input-group>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Model/type/Series</label></b-input-group-prepend>
                        <b-form-input v-model="model.asmodel"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="2" >
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2">Year &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asyermad"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="4">                            
                    <b-input-group >
                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>S/N</label></b-input-group-prepend>
                        <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>S/N &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asserial" placeholder="Serial Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col lg="7" >
                    <b-input-group >
                        <b-input-group-prepend><label>Warranty Desc./Note</label></b-input-group-prepend>
                        <b-form-input v-model="model.txtgaransi"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                    <b-input-group >
                        <b-input-group-prepend><span class="input-group-text">Expired Date</span></b-input-group-prepend>
                        <b-form-input v-model="model.tglgaransi" type="date" ></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Brand/Merk</label></b-input-group-prepend>
                        <b-form-input v-model="model.brand" ></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                        <b-form-input v-model="model.vendorinfo" placeholder="Vendor Code | Vendor Name"></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>

                <b-row >
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Other Information</label></b-input-group-prepend>
                        <b-form-input v-model="model.otherinfo" placeholder="e.g Nomor Polisi, Computer Card, Unique Code"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">    
                    <b-input-group >
                        <b-input-group-prepend><label>Reference Doc.#</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomorpo" ></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
          </b-col>
          <b-col class="pr-4" lg="5">
              <b-input-group>
                <b-input-group-prepend><label>User of Asset </label></b-input-group-prepend>
                  <div style="flex: 1 1 auto;width: 1%;" >
                    <b-form-radio-group  v-model="model.aspublic" @change="clearDepartment" class="pt-1">
                        <b-form-radio value="0">Dedicated Employee </b-form-radio>
                        <b-form-radio value="1">Department's Asset</b-form-radio>
                        <b-form-radio value="-1">Available(Not Used)</b-form-radio>
                    </b-form-radio-group>                  
                  </div>
              </b-input-group>          
              <b-input-group v-if="(model.aspublic==0)">
                  <b-input-group-prepend><label>Dedicated Employee</label></b-input-group-prepend>
                  <b-form-input readonly v-model="model.crewinfo" :state="!$v.model.crewkey.$error"></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="lkuCrewShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
                  <b-input-group-append>
                      <b-btn text="Button" @click="clearCrew" class="ml-1"> Clear</b-btn>
                  </b-input-group-append>
                <!-- <b-form-checkbox  class="mt-2 ml-1" v-model="model.aspublic" @change="clearDepartment" :value=-1 unchecked-value=0 >Available (Not Used)</b-form-checkbox> -->
              </b-input-group>
                <b-input-group v-if="(model.aspublic!=-1)">
                  <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                    <b-form-input readonly v-model="model.userdepartname" :state="!$v.model.userdepartid.$error"></b-form-input>
                    <b-input-group-append>
                        <b-btn text="Button" @click="lkuDepartmentShow=true" ><i class="fa fa-search"></i></b-btn>
                    </b-input-group-append>
                        <b-form-input v-model="model.asuser" placeholder="usage remark" class="ml-1"></b-form-input>
                </b-input-group>

                <b-input-group v-if="(model.aspublic==-1)">
                      <!-- <b-input-group-prepend><label>Inventory Store</label></b-input-group-prepend>
                      <b-form-select v-model="model.idStore" :plain="true" :options="warehouse" :state="!$v.model.idStore.$error" disabled ></b-form-select> -->
                      <b-link href="#" @click="mutationForm">Lakukan Pengembalian FA sbg barang Inventory Gudang via menu "Fixed Asset Mutation Form"</b-link>
                      <!-- <b-input-group-prepend><span class="input-group-text">Lakukan Pengembalian FA sbg barang Inventory Gudang via menu MUTASI  </span></b-input-group-prepend> -->
                </b-input-group>

                <b-input-group >
                    <b-input-group-prepend><label>Location of Asset</label></b-input-group-prepend>
                    <b-form-input readonly v-model="model.lokasiinfo"></b-form-input>
                    <b-input-group-append>
                    <b-btn text="Button" @click="lkuLocationShow=true" >
                        <i class="fa fa-search"></i>
                    </b-btn>
                    </b-input-group-append>
                    <b-form-input v-model="model.aslocat" placeholder="location remark" class="ml-1"></b-form-input>
                </b-input-group>
                <b-row no-gutters>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Last Opname/Audit</label></b-input-group-prepend>
                        <b-form-input v-model="model.opnamelastd" type="date" ></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><span class="input-group-text">Status</span></b-input-group-prepend>
                        <b-form-input v-model="model.opnamestatus"></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                    <b-input-group >
                        <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                        <b-form-input v-model="model.catgname" disabled></b-form-input>                                        
                    </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Mstr. Material Reff</label></b-input-group-prepend>
                      <b-form-input readonly v-model="model.iteminfo" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuItemShow=true" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>                

                <!-- <b-row>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                        <b-form-input v-model="model.catgname" disabled></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Managed by Dept.</label></b-input-group-prepend>
                        <b-form-input v-model="model.departmenpic" disabled></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row> -->

          </b-col>
      </b-row>
      <b-card title="Detail/Component Asset (Sub Asset)">
        <b-table
            class="mb-0"
            ref="tblGroup"
            outlined
            striped hover small 
            style="font-size:smaller;"
            :items="assetchild.list"
            :fields="assetchild.fields"
            :current-page="assetchild.page"
            :per-page="assetchild.limit"
          >
              <template v-slot:cell(index)="data">
                {{data.index + 1}}
              </template>
              <template v-slot:cell(tanggal)="data">
                <span v-if="(data.item.tanggal)">{{data.item.tanggal| moment('D-MMM-YY')}}</span>
              </template>
              <template v-slot:cell(uomValue)="data">
                <span v-if="(data.item.uomValue)">{{data.item.uomValue}} {{data.item.uomCode}} </span>
              </template>

              <template v-slot:cell(action)="data">
                <div class="text-center">
                <a href="javascript:void(0)" class="text-danger" @click="delChild(data.item)">
                  <i class="fa fa-trash"></i>
                </a>
                </div>
            </template>
        </b-table>
        <b-row>
          <b-col cols="5">
            <b-row>
              <b-button size="sm" class="btn btn-primary ml-3" @click="addChild" >Add Component</b-button>                          
              <div class="ml-2">
                Showing
                {{(assetchild.page - 1) * assetchild.limit + 1}}
                to
                {{assetchild.page * assetchild.limit}}
                of
                {{assetchild.total}}
                entries
              </div>    
            </b-row>                    
          </b-col>
          <b-col cols="3">            
              <b-row class="ml-2 mt-2">
                <span class="pt-1 pr-2">Limit per page</span>
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="assetchild.limit"  size="sm" style="width:80px !important;"/>
              </b-row>
          </b-col>
          <b-col cols="4">            
            <b-pagination
              align="right"
              :total-rows="assetchild.total"
              :per-page="assetchild.limit"
              v-model="assetchild.page"
            ></b-pagination>
          </b-col>
        </b-row>
                <b-row class="justify-content-center mt-1 mb-1">
                    <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                    <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
                </b-row>

      </b-card>
    </b-card>
        <b-modal v-model="showForm" header-bg-variant="primary" size="xl" title="Form - Asset Component" :centered="true" @ok="saveChild">
                <b-row no-gutters >
                  <b-col lg="5" >
                    <b-input-group class="pr-1">
                        <b-input-group-prepend><label>Fixed Asset</label></b-input-group-prepend>
                        <b-form-input v-model="childObj.childAsetid" readonly></b-form-input>  
                    </b-input-group>
                  </b-col>
                  <b-col lg="7">                            
                    <b-input-group >
                        <b-form-input v-model="childObj.childAsetName" :state="!$v.childObj.childAsetName.$error" readonly></b-form-input>                                        
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuFixedAssetShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>

                <!-- <b-input-group >
                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                    <b-form-input v-model="childObj.childAsetName" :state="!$v.childObj.childAsetName.$error"></b-form-input>
                </b-input-group> -->
                <b-row>
                  <b-col cols="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Serial Number</label></b-input-group-prepend>
                        <b-form-input v-model="childObj.childSerialNo" ></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col cols="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Status</label></b-input-group-prepend>
                        <b-form-input v-model="childObj.childStatus" ></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
        </b-modal>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
        </b-modal>        
        <b-modal v-model="lkuDepartmentShow" size="lg" :hide-footer="true" title="List of Department" :centered="true">
            <lku-department @click="onSelectLkuDepartment"></lku-department>
        </b-modal>     
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item" :centered="true">
            <lku-item @click="onSelectLkuItem"   :formdata="itemList"></lku-item>
        </b-modal>        
        <b-modal v-model="lkuLocationShow" size="lg" :hide-footer="true" title="List of Location" :centered="true">
            <lku-location @click="onSelectLkuLocation"></lku-location>
        </b-modal>        
        <b-modal v-model="lkuFixedAssetShow" size="lg" :hide-footer="true" title="List of Fixed Asset" :centered="true">
            <lku-fixedasset @click="onSelectLkuFixedAsset" outstand="1" :formdata="lkuFixedAssetData"></lku-fixedasset>
        </b-modal>    

        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

  </div>
</template>

<style lang="scss">
    .table-wraper {
         width:100%;
         height:380px;
         overflow-x: auto;
         overflow-y: auto;
        border: 1px solid silver;
    }
</style>


<script>
import toastr from "mini-toastr";
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import myNumber from "../../components/my-number";
import lkuCrew from "../lookup/lkuCrewlazzy";
import lkuItem from "../lookup/lkuItemLazzy";
import lkuFixedasset from "../lookup/lkuFassetLazzy";
import lkuDepartment from "../lookup/lkuDepartment";
import lkuLocation from "../lookup/lkuAssetlocat";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import fixedasset from '../../apis/fixedasset';
toastr.init();

export default {
  components: { Loading, myNumber, lkuItem, lkuFixedasset, lkuCrew,lkuDepartment, lkuLocation},
  mixins: [validationMixin],
  validations: {
    model: {
        asdesc: { required },
          aspublic: { required},
          userdepartid: {required : (function() {
                if ((this.model.aspublic || 0) != 0) {
                    return true;
                } else if (!(this.model.userdepartid)){
                    return false;
                } else return true;
            })},
          crewkey: {required : (function() {
                if ((this.model.aspublic || 0) != 1) {
                    return true;
                } else if (!(this.model.crewkey)){
                    return false;
                } else return true;
            })},
          idStore: {required : (function() {
                if ((this.model.aspublic || 0) != -1) {
                    return true;
                } else if (!(this.model.idStore)){
                    return false;
                } else return true;
            })},
    },
    childObj: {
        asetkey: { required },
        childAsetName: { required },
    },

  },   
  data() {
    return {
      isLoading:false,
      saveEnabled: true,
      showForm: false,
      lkuCrewShow:false,
      lkuCrewData:{},
      lkuDepartmentShow:false,
      lkuItemShow:false,
      itemList:{},
      lkuFixedAssetData:{},
      lkuFixedAssetShow: false,
      lkuLocationShow:false,
      model:{asdesc:'', aspublic:0, crewkey:'', userdepartid:'', idStore:''},
        childObj:{asetkey:'', asetid:'', childAsetName:''},
        assetchild: {
            list: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                  key: "childAsetid",
                  label: "FA Sub Number",
                  sortable: true
                },
                {
                  key: "childAsetName",
                  label: "FA Name/Description",
                  sortable: true
                },
                {
                  key: "childSerialNo",
                  label: "Serial Number",
                  sortable: true
                },
                {
                  key: "childStatus",
                  label: "Status",
                  sortable: true
                },
                {
                  key: "partnumber",
                  label: "Material/Part Number",
                  sortable: true
                },
                {
                  key: "action",
                  label: "action",
                  thClass: "text-center",
                  tdClass: "text-center",
                },

            ],
            page: 1,
            limit: 10,
            total: 0,
            sortBy:'childAsetid'
        },
    }
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidChild() {
      this.$v.childObj.$touch();
      return this.$v.childObj.$invalid;
    },
  },
  created: async function (){
      this.lblExchRate=`Exch. Rate to ${this.uanguser}`;
      if (this.$route.params.asetkey)  {
          toastr.info('Loading Fixed Asset Detail, please wait')
          try {
            const data = await fixedasset.detailga(this.$route.params);  
            console.log('childs: ', data[1]);
            const row = data[0];
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.aspublic = this.model.aspublic || 0;
            this.model.asdatacq = row.asdatacq ? moment(row.asdatacq).format('YYYY-MM-DD') : '';
            // this.model.asdatuse = row.asdatuse ? moment(row.asdatuse).format('YYYY-MM-DD') : '';
            this.model.tglgaransi = row.tglgaransi ? moment(row.tglgaransi).format('YYYY-MM-DD') : '';
            // this.model.tglAkhirDepr = row.tglAkhirDepr ? moment(row.tglAkhirDepr).format('YYYY-MM-DD') : '';
            // this.amortzHist.items = data[1];
            this.model.opnamelastd = row.opnamelastd ? moment(row.opnamelastd).format('YYYY-MM-DD') : '';
            this.assetchild.list=data[1];
            this.$forceUpdate();
            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } 
  },
  methods: {
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    onSelectLkuFixedAsset(lkuData) {
        this.lkuFixedAssetData=lkuData;
        this.lkuFixedAssetShow=false;
        // this.model.asetid = lkuData.selected.asetid;
        // this.model.asdesc = lkuData.selected.asdesc;
        // this.model.lamathn = lkuData.selected.lamathn;
        // this.model.lamabln = lkuData.selected.lamabln;
        // this.model.depaccum = lkuData.selected.Penyusutan;
        // this.model.catgid = lkuData.selected.catgid;
        // this.model.catgname = lkuData.selected.catgname;
        // this.model.matauang = lkuData.selected.matauang;
        // this.model.asmodel = lkuData.selected.asmodel;
        // this.model.asserial = lkuData.selected.asserial;
        // this.model.asyermad = lkuData.selected.asyermad;
        // this.model.supplierinfo = lkuData.selected.supplierinfo;
        // this.model.aspurcpri = lkuData.selected.aspurcpri;
        // this.model.asdatacq = moment(lkuData.selected.asdatacq).format('YYYY-MM-DD');

        // this.childObj.iteminfo = lkuData.selected.asetid+ ' | ' + lkuData.selected.itemname.trim();
        // this.childObj.partnumber = '';
        this.childObj.asetkey= this.model.asetkey;
        this.childObj.asetid= this.model.asetid;
        this.childObj.asetChildKey = lkuData.selected.asetkey;
        this.childObj.childAsetid = lkuData.selected.asetid;
        this.childObj.childAsetName = lkuData.selected.asdesc;
        this.childObj.childSerialNo = lkuData.selected.asserial;
        // this.childObj.iteminfo = lkuData.selected.partnumber.trim() + ' | ' + lkuData.selected.itemname.trim();
        // this.childObj.partnumber = lkuData.selected.partnumber;
        // this.childObj.itemno = lkuData.selected.itemno;
        // this.childObj.itemname = lkuData.selected.itemname;
    },

    onSelectLkuItem(lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;

        this.model.iteminfo = lkuData.selected.partnumber.trim() + ' | ' + lkuData.selected.itemname.trim();
        this.model.partnumber = lkuData.selected.partnumber;
        this.model.itemno = lkuData.selected.itemno;
        this.model.itemname = lkuData.selected.itemname;
    },
    onSelectLkuCrew:  function (lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
        this.model.crewinfo = lkuData.selected.crewnik.trim() + ' | ' + lkuData.selected.crewname.trim();
        this.model.crewkey = lkuData.selected.crewkey;
        this.model.crewnik = lkuData.selected.crewnik;
        this.model.jabatan = lkuData.selected.jabatan;
        // this.model.departemen = lkuData.selected.departemen;
        this.model.userdepartname = lkuData.selected.departemen.trim();
        this.model.userdepartid = lkuData.selected.departid;
        this.model.aspublic=0;
    },
    onSelectLkuDepartment:  function (_selected) {
        this.model.userdepartname = _selected.departemen.trim();
        this.model.userdepartid = _selected.departid;
        this.model.userdepartkd = _selected.departkd;
        this.model.aspublic=0;
        this.lkuDepartmentShow=false;
    },
    onSelectLkuLocation:function (_selected) {
        this.model.lokasiinfo = _selected.kodelokasi.trim() + ' | ' + _selected.namalokasi.trim();
        this.tblData.aslocat = _selected.namalokasi.trim();
        this.model.aslocatkey = _selected.aslocatkey;
        this.model.kodelokasi = this.model.kodelokasi;
        this.model.namalokasi = _selected.namalokasi;
        this.lkuLocationShow=false;
    },
    clearCrew: function() {
        this.model.crewinfo = '';
        this.model.crewkey = '';
        this.model.crewnik = '';
        this.model.jabatan = '';
    },
    clearDepartment: function() {
        this.model.userdepartname = '';
        this.model.userdepartid ='';
        this.model.userdepartkd = '';
    },
    save: async function () {
        if (this.invalidModel) {
                const invalidobj={};
                for (var key in this.$v.model) {
                  if (this.$v.model[key].$anyError) {
                    if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
                  }
                }        
                console.log('validation model: ', this.$v.model);
                console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              this.isLoading=true;
              let data= {}
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
              // data.asdatacq = moment(this.model.asdatacq).format('YYYY-MM-DD');
              // data.asdatuse = (this.model.asdatuse) ? moment(this.model.asdatuse).format('YYYY-MM-DD') : '';
              data.tglgaransi = (this.model.tglgaransi) ? moment(this.model.tglgaransi).format('YYYY-MM-DD') : '';
              data.opnamelastd = (this.model.opnamelastd) ? moment(this.model.opnamelastd).format('YYYY-MM-DD')  : '';

              const hasil = await fixedasset.savegainfo(data);
              toastr.success(`Save Success, ${hasil.asetid}`, "Fixed Asset",10000);
              this.isLoading=false;
              this.close();
            } catch (error) {
              this.isLoading=false;
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
            }
        }
    },
    addChild : function () {
        for (var key in this.childObj) {
            this.childObj[key] = '';
        }
      this.childObj.asetkey= this.model.asetkey;
      this.childObj.asetid= this.model.asetid;
      this.$v.childObj.$reset();
      this.showForm=true;

    },
    editChild: function(data) {
        for (var key in this.childObj) {
            this.childObj[key] = '';
        }
        for (var key in data) {
            this.childObj[key] = data[key];
        }
        this.childObj.iteminfo = this.childObj.partnumber ? this.childObj.partnumber.trim() + ' | ' + this.childObj.itemname.trim() : '';
        this.childObj.asetkey= this.model.asetkey;
        this.childObj.asetid= this.model.asetid;

      this.$v.childObj.$reset();
      this.showForm=true;
    },

    delChild:  function (data) {
      this.terpilih=data;
        this.$bvModal.msgBoxConfirm(`${this.terpilih.childAsetid} | ${this.terpilih.childAsetName} will be deleted, Are you sure?`)
          .then(async (value) => {
            if (value==true){
              try {
                await fixedasset.removechild(data);
                this.refreshChild();
              } catch (error) {
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
              }
            }
          })
          .catch(err => {
            // An error occurred
          })

    },
    refreshChild: async function () {
      this.isLoading=true;
      this.assetchild.asetkey = this.model.asetkey;
      this.assetchild.sortDir = this.assetchild.sortDesc ? "desc" : "asc";
      const list = await fixedasset.listchild(this.assetchild);      
      this.isLoading=false;
      this.assetchild.list= list;
    },
    saveChild: async function (evt) {
        // evt.preventDefault()
        if (this.invalidChild) {
            console.log('validation model : ', this.$v.childObj);
            console.log('model obj : ',this.childObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {              
              try {
                const hasil = await fixedasset.savechild(this.childObj);
                toastr.success(`Save Success, ${hasil.childAsetid}`, "Fixed Asset",10000);

                this.showForm=false;
                this.refreshChild();
              } catch (error) {
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
              }
        }
    },
    close(){
      // if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'fixedasset.form')) {
      //   router.push({name:this.$store.state.prevRoute.name});
      // } else {
        router.push({name:'fixedasset.listga'});
      // }
    },    
    mutationForm(){
      router.push({name:'fixedasset.mutationfrm'});
    }
  }
};
</script>
